module.exports = __webpack_public_path__ + "static/media/cardImg2.963e94bb.jpg";